// frontend/src/services/api.js
import axios from 'axios';

// 创建 axios 实例
const apiClient = axios.create({
  baseURL: '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// 请求拦截器
apiClient.interceptors.request.use(
    config => {
        // 只在开发环境打印详细config日志
        if (process.env.NODE_ENV === 'development') {
            console.log('Request Interceptor - START, Config:', config.method?.toUpperCase(), config.url);
        }
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['x-access-token'] = token;
            if (process.env.NODE_ENV === 'development') console.log('Request Interceptor - Token added.');
        } else {
            if (process.env.NODE_ENV === 'development') console.log('Request Interceptor - No token found.');
        }
        return config;
    },
    error => {
        console.error('Request Interceptor - Error preparing request:', error);
        return Promise.reject(error);
    }
);

// 响应拦截器
apiClient.interceptors.response.use(
    response => {
        if (process.env.NODE_ENV === 'development') {
            console.log('Response Interceptor - Successful response for:', response.config.method?.toUpperCase(), response.config.url, 'Status:', response.status);
            // console.log('Response data:', response.data); // 可以取消注释看详细数据
        }
        return response;
    },
    error => {
        console.error('Response Interceptor - Error object received for:', error.config?.method?.toUpperCase(), error.config?.url);
        if (error.response) {
            console.error('Response Interceptor - error.response.status:', error.response.status);
            console.error('Response Interceptor - error.response.data:', error.response.data);
        } else if (error.request) {
            console.error('Response Interceptor - error.request (no response received):', error.request);
        } else {
            console.error('Response Interceptor - Error setting up request:', error.message);
        }
        // console.error('Response Interceptor - error.config (request config):', error.config);
        return Promise.reject(error);
    }
);

// --- Auth ---
export const login = (credentials) => {
    if (process.env.NODE_ENV === 'development') console.log('API Service: login with credentials:', credentials);
    return apiClient.post('/login', credentials);
};

// registerUser(userData) { // If needed
//     return apiClient.post('/register', userData);
// },

// --- Librarians ---
// MODIFIED HERE:
export const getLibrarians = () => {
    if (process.env.NODE_ENV === 'development') console.log('API Service: getLibrarians (now fetching from /contacts)');
    return apiClient.get('/contacts'); // Changed from '/librarians' to '/contacts'
};

export const getLibrarianById = (id) => {
    // 已修改为使用 /contacts/:id 端点
    if (process.env.NODE_ENV === 'development') console.log(`API Service: getLibrarianById for ID: ${id} (using /contacts/${id})`);
    return apiClient.get(`/contacts/${id}`);
};

export const createLibrarian = (librarianData) => {
    if (process.env.NODE_ENV === 'development') console.log('API Service: createLibrarian with data:');
    return apiClient.post('/contacts', librarianData);
};

export const updateLibrarian = (librarianId, librarianData) => {
    if (process.env.NODE_ENV === 'development') console.log(`API Service: updateLibrarian for ID: ${librarianId} with data:`);
    return apiClient.put(`/contacts/${librarianId}`, librarianData);
};

export const softDeleteLibrarian = (librarianId, passwordConfirmation) => { 
    if (process.env.NODE_ENV === 'development') console.log(`API Service: softDeleteLibrarian for ID: ${librarianId}`);
    return apiClient.delete(`/contacts/${librarianId}`, { data: passwordConfirmation });
};

export const importLibrarians = (formData) => {
    if (process.env.NODE_ENV === 'development') console.log('API Service: importLibrarians (POST with FormData)');
    return apiClient.post('/contacts/import', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

// --- Contact Logs --- 
// These seem to refer to a different entity "contact_logs" and might be okay.
// However, if "contacts" are now "librarians", the term "contact_logs" might become confusing.
export const addContactLog = (data) => {
    if (process.env.NODE_ENV === 'development') console.log('API Service: addContactLog with data:', data);
    return apiClient.post('/contact-logs', data); // Assuming /contact-logs is correct and distinct
};

export const getLibrarianContactLogs = (librarianId) => {
    if (process.env.NODE_ENV === 'development') console.log(`API Service: getLibrarianContactLogs for librarian ID: ${librarianId}`);
    return apiClient.get(`/contact-logs?librarian_id=${librarianId}`);
};

export const exportContactLogs = (params) => {
    if (process.env.NODE_ENV === 'development') console.log('API Service: exportContactLogs with params:', params);
    return apiClient.get('/export', { params, responseType: 'blob' });
};

// --- User Management ---
export const getUsers = () => {
    if (process.env.NODE_ENV === 'development') console.log('API Service: getUsers');
    return apiClient.get('/users');
};

export const createUser = (userData) => {
    if (process.env.NODE_ENV === 'development') console.log('API Service: createUser with data:', userData);
    return apiClient.post('/users', userData);
};

export const updateUser = (userId, userData) => {
    if (process.env.NODE_ENV === 'development') console.log(`API Service: updateUser for ID: ${userId} with data:`, userData);
    return apiClient.put(`/users/${userId}`, userData);
};

export const changePassword = (userId, passwordData) => {
    if (process.env.NODE_ENV === 'development') console.log(`API Service: changePassword for ID: ${userId}`);
    return apiClient.put(`/users/${userId}/password`, passwordData);
};

export const deleteUser = (userId, passwordConfirmation) => {
    if (process.env.NODE_ENV === 'development') console.log(`API Service: deleteUser for ID: ${userId}`);
    return apiClient.delete(`/users/${userId}`, { data: passwordConfirmation });
};
    
export const updateContactLog = (logId, logData) => { 
    if (process.env.NODE_ENV === 'development') console.log(`API Service: updateContactLog for ID: ${logId} with data:`, logData);
    return apiClient.put(`/contact-logs/${logId}`, logData); // Assuming /contact-logs/:id is correct
};